/* eslint-disable import/prefer-default-export */
import { FieldPolicy, Reference } from '@apollo/client'

import { FilterAssetsInput } from '~generated/types'

type PaginatedAssetGroupsCacheObj = {
  docs?: Record<string, Reference>
  limit?: number
  page?: number
  totalPages?: number
}

type PaginatedAssetGroupsObj = {
  docs?: Reference[]
  limit?: number
  page?: number
  totalPages?: number
}

export function createPaginatedAssetGroupsQueryCache(): FieldPolicy<
  PaginatedAssetGroupsCacheObj,
  PaginatedAssetGroupsObj,
  PaginatedAssetGroupsObj
> {
  return {
    keyArgs: () => {
      const filterKeysDict: KeysEnum<FilterAssetsInput> = {
        approverIds: true,
        ownerIds: true,
        tagIds: true,
        launchIds: true,
        types: true,
        approvalStatuses: true,
        isBrandAsset: true,
        isEmpty: true,
        createdAtLte: true,
        createdAtGte: true,
        query: true,
      }

      return ['filter', Object.keys(filterKeysDict), 'pagination', ['limit']]
    },

    merge: (existing, incoming, { readField, canRead, isReference }) => {
      const { docs: existingDocs = {} } = existing || {}
      const { docs: incomingDocs = [] } = incoming

      const docs = {}

      Object.values(existingDocs).forEach((doc) => {
        if (isReference(doc) && canRead(doc)) {
          docs[readField<string>('key', doc)] = doc
        }
      })

      incomingDocs.forEach((doc) => {
        if (isReference(doc) && canRead(doc)) {
          docs[readField<string>('key', doc)] = doc
        }
      })

      return {
        ...existing,
        ...incoming,
        docs,
      }
    },

    read: (existing) => {
      if (!existing) return undefined

      return {
        ...existing,
        docs: Object.values(existing.docs),
      }
    },
  }
}
